export default __webpack_public_path__ + "c5f8f2ead90f3eceabd8c22ddce20fd1.png";